export {HomeComponent} from './home/home.component';




// WEBPACK FOOTER //
// ./src/app/components/views/index.ts